module.exports = __webpack_public_path__ + "static/media/cricketgame.c014e22a.png";